import React, { Children, ReactElement, ReactNode } from 'react';
import { Card, CardHeader, CardContent, Grid, Box, Stack } from '@mui/material';
import { PayerLoadingOverlay } from '../containers/PayerLoadingOverlay';
import { CardTitleWithSpinnerAndChip } from './CardTitleWithSpinnerAndChip';

export type DetailedCardProps = {
  title: string;
  statusChip?: ReactElement;
  rightHeader?: ReactNode;
  active: boolean;
  display: boolean;
  grayBackground?: boolean;
  children: ReactElement | (ReactElement | false | null | undefined)[];
};

export const DetailedCard = ({
  title,
  statusChip,
  rightHeader,
  active,
  display,
  grayBackground,
  children,
}: DetailedCardProps) => {
  return (
    <PayerLoadingOverlay active={active}>
      {display && (
        <Card>
          <CardHeader
            title={
              <Stack direction="column" sx={{ p: '0.75rem 1.25rem' }}>
                <CardTitleWithSpinnerAndChip statusChip={statusChip} title={title} isWaiting={active} />
              </Stack>
            }
            sx={{
              p: 0,
              backgroundColor: '#f0f3f5',
              borderBottom: '1px solid #c8ced3',
              alignItems: 'center',
              '& .MuiCardHeader-action': { alignSelf: 'center' },
            }}
            action={
              rightHeader ? (
                <Box display="flex" px={2}>
                  {rightHeader}
                </Box>
              ) : null
            }
          />
          <CardContent style={grayBackground ? { backgroundColor: '#eeeeee' } : undefined}>
            <Grid container spacing={2}>
              {Children.map(
                children,
                child =>
                  child && (
                    <Grid item sm={12}>
                      {child}
                    </Grid>
                  ),
              )}
            </Grid>
          </CardContent>
        </Card>
      )}
    </PayerLoadingOverlay>
  );
};
